import { render, staticRenderFns } from "./home_mobile.vue?vue&type=template&id=f0a9df06&scoped=true&"
import script from "./home_mobile.vue?vue&type=script&lang=js&"
export * from "./home_mobile.vue?vue&type=script&lang=js&"
import style0 from "./home_mobile.vue?vue&type=style&index=0&id=f0a9df06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a9df06",
  null
  
)

export default component.exports